/** MECC weight-intervention band per HSE CDM dataset Ref 25–27. */
export const WEIGHT_MECC_BAND = {
  HIGH: "HIGH",
  INCREASED: "INCREASED",
  NORMAL: "NORMAL",
};

/**
 * Which weight brief-intervention field is mandatory for the patient's BMI.
 * Returns null when BMI is missing/invalid — all three fields stay optional.
 */
export const getWeightMeccBand = (bmi) => {
  const bmiNumber = Number(bmi);

  if (!bmi || Number.isNaN(bmiNumber)) {
    return null;
  }

  if (bmiNumber < 18.5 || bmiNumber > 30) {
    return WEIGHT_MECC_BAND.HIGH;
  }

  if (bmiNumber >= 25 && bmiNumber <= 30) {
    return WEIGHT_MECC_BAND.INCREASED;
  }

  if (bmiNumber >= 18.5 && bmiNumber <= 24.9) {
    return WEIGHT_MECC_BAND.NORMAL;
  }

  return null;
};
